import { createSlice } from '@reduxjs/toolkit';
import { getDocumentListByLinerAndCountry } from './actions/DocumentMasterActions';

interface DocumentMasterState {
    documentList?: any[];
}

const initialState: DocumentMasterState = {
    documentList: [],
};

const DocumentMasterSlice = createSlice({
  name: 'documentMaster',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDocumentListByLinerAndCountry.fulfilled, (state, action) => {
      state.documentList = action.payload;
    });
  }
});

export default DocumentMasterSlice;